/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The account's scope.
 *
 * Determines if the resource is a regular account or a client account.
 *
 */
export var AccountScope;
(function (AccountScope) {
    AccountScope["ACCOUNT"] = "account";
    AccountScope["CLIENT_ACCOUNT"] = "client_account";
})(AccountScope || (AccountScope = {}));
//# sourceMappingURL=AccountScope.js.map